import React from "react";
import styles from "./iconButton.css";

export const IconButton = (props: React.InputHTMLAttributes<HTMLInputElement>) => {
  const { onClick, ...restProps } = props;
  const handleClick = (e: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
    e.preventDefault();
    onClick?.(e);
  };

  return (
    <input
      onClick={handleClick}
      type="image"
      className={props.disabled ? styles.disabled : ""}
      {...restProps}
    />
  );
};
